import { COLORS } from '@avalara/bat-apps-shared/constants';
import styled, { css } from 'styled-components';

export const Slider = styled.div<{ show: boolean }>`
  display: block;
  max-height: 0;
  overflow-y: hidden;
  transition: max-height .5s cubic-bezier(0, 1, 0, 1) -.1s;
  ${(props) =>
    props.show &&
    css`
    max-height: 9999px;
    transition-delay: 0s;
    transition-timing-function: cubic-bezier(0.5, 0, 1, 0);
  `}
`;

export const BlueHeading = styled.h3`
  color: ${COLORS.darkBlue};
`;

export const CheckItem = styled.div<{ leftPadSize?: number }>`
  font-size: 18px !important;
  padding-left: ${(props) => props.leftPadSize || 0}px;
  display: flex;
  align-items: baseline;

  *:not(h1, h2, h3, h4, h5) {
    font-size: inherit;
  }

  s-icon {
    color: ${COLORS.darkBlue};
  }

  s-col {
    min-width: auto;
  }

  span {
    padding: 8px;
    display: inline-block;
  }
`;
